import React from "react";
import { BrowserRouter } from "react-router-dom";
import Router from "./routes";
import theme from "./theme";
import { ChakraProvider, ColorModeScript } from "@chakra-ui/react";
import { AppProvider } from "./contexts";

function App() {
  return (
    <>
      <ChakraProvider>
        <ColorModeScript initialColorMode={theme.config.initialColorMode} />
        <BrowserRouter>
          <AppProvider>
            <Router />
          </AppProvider>
        </BrowserRouter>
      </ChakraProvider>
    </>
  );
}

export default App;
